import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import ScannerHtml5 from "./ScannerHtml5";
import config from "../../config/config";
import { toastError, toastSuccess, toastWarn } from "../../common/Toast";
// import GeorapBox from "../Pos/GeorapBox/GeorapBox";

function Scanner({
  customerData,
  callbackBulkCartData,
  setStartScannerCamera,
}) {
  const token = localStorage.getItem("Token") || "";
  const Location = localStorage.getItem("Location") || 0;
  const LoginId = localStorage.getItem("ID") || 0;

  const [decodedResults, setDecodedResults] = useState([]);
  const [scannerValue, setScannerValue] = useState("");
  const [itemsList, setItemsList] = useState([]);
  const [isModal, setIsModal] = useState(true);

  // const onNewScanResult = (decodedText, decodedResult) => {
  //   // type of QR datails store
  //   // toastSuccess(decodedText);
  //   setDecodedResults((prev) => [...prev, decodedResult]);
  //   setScannerValue(decodedText);
  // };
  const onNewScanResult = (decodedText) => {
    // type of QR datails store
    console.log(decodedText, "decodedText");
    // toastSuccess(decodedText);
    // setDecodedResults((prev) => [...prev, decodedResult]);
    setScannerValue(decodedText);
  };

  console.log(itemsList, "itemsList");
  console.log(scannerValue, "scannerValue");

  useEffect(() => {
    // toastSuccess("call api")
    if (scannerValue) {
      axios
        .get(
          `${config.ecommBackendBaseUrl}/products/productDataByItemNumber?sacnId=${scannerValue}&loginId=${customerData?.Id}&roleId=${customerData?.RoleTierID}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
            },
          }
        )
        .then((res) => {
          console.log("HelloWorldddddddd", res.data.ResponseData);
          const mainData = res.data.ResponseData;
          if (mainData?.length > 0) {
            // setNewItemInCart(mainData[0].)

            const findIndex = itemsList?.findIndex(
              (el) =>
                el.ID === mainData[0].ID &&
                el.variationId === mainData[0].variationId
            );

            if (findIndex != -1) {
              // const newList = [...itemsList];
              // newList[findIndex].inputQuantity =
              //   Number(newList[findIndex].inputQuantity) + 1;
              // setItemsList(newList);

              const newList = [...itemsList];
              const itemToMove = newList[findIndex];
              itemToMove.inputQuantity = Number(itemToMove.inputQuantity) + 1;
              newList.splice(findIndex, 1);
              newList.unshift(itemToMove);
              setItemsList(newList);

              toastSuccess(
                `Name: ${mainData[0].Name} | ${
                  Number(mainData[0].Quantity) > 0
                    ? `InStock: ${mainData[0].Quantity || 0}`
                    : "Out Of Stock"
                } | Qty Updated: ${
                  Number(newList[findIndex].inputQuantity) + 1
                } | Price: ${mainData[0].FinalPrice || 0}`,
                "bottom-center"
              );
            } else {
              setItemsList((prev) => [
                { ...mainData[0], inputQuantity: 1 },
                ...prev,
              ]);
              toastSuccess(
                `${
                  Number(mainData[0].Quantity) > 0
                    ? `Name: ${mainData[0].Name} | InStock: ${
                        mainData[0].Quantity || 0
                      } | Qty Added: 1 | Price: ${mainData[0].FinalPrice || 0}`
                    : `Name: ${
                        mainData[0].Name
                      } | Out of Stock | Qty Added: 1 | Price: ${
                        mainData[0].FinalPrice || 0
                      }`
                }`,
                "bottom-center"
              );
            }
          } else {
            toastError("Item Not Found!", "bottom-center");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // setScannerValue('');
    }
  }, [scannerValue]);

  const deleteItem = (index) => {
    const updatedItemsList = itemsList.filter((_, i) => i !== index);
    // Update the itemsList with the filtered array
    setItemsList(updatedItemsList); // Assuming you are using React state

  };
  useEffect(() => {
    if(itemsList.length === 0){
      setIsModal(true)
    }
  })

  const handleItemQty = (type, index, item) => {
    const newList = [...itemsList];
    newList[index].inputQuantity =
      Number(item.inputQuantity) + (type === "increase" ? 1 : -1);
    setItemsList(newList);
  };

  const variationQtyInput = (value, index, item, field) => {
    const newList = [...itemsList];
    newList[index][field] = value;
    setItemsList(newList);
  };

  const bulkAddToCart = (e) => {
    e.preventDefault();
    setIsModal(true);
    callbackBulkCartData(itemsList);
    setItemsList([]);
  };

  return (
    <div className="">
      {/* <BreadCrumb breacrumb={breadCrumb} layout="fullwidth" /> */}
      <div style={{ padding: "0px" }}>
        {/* <ScannerHtml5
          fps={30}
          qrbox={300}
          disableFlip={false}
          qrCodeSuccessCallback={onNewScanResult}
        /> */}
        {/* {isModal && (
          <GeorapBox
            qrCodeSuccessCallback={onNewScanResult}
            setStartScannerCamera={setStartScannerCamera}
          />
        )} */}
      </div>
      <div className="ps-container" style={{ paddingBottom: "40px" }}>
        {/* <ResultContainerPlugin results={decodedResults} /> */}

        {itemsList
          ?.filter((_, i) => (isModal ? i === 0 : true))
          ?.map((item, index) => (
            <div
            // style={{borderTop:"1px solid #cfcfcf" , paddingTop:"10px"}}
            >
              <div className="row">
                <p className="col-10">{item.Name} </p>
                <div className="col-2">
                  <button
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      backgroundColor: "transparent",
                      padding: "0px",
                    }}
                    onClick={() => deleteItem(index)}
                    // className="pos-ps-btn pos-button_rp btn-blk_Qty m-2"
                  >
                    <i className="fa fa-trash-o fs-5"></i>
                    {/* Delete */}
                  </button>
                </div>
              </div>
              <div className="d-flex justify-content-between col-auto align-items-center gap-2">
                <div className="col-md-4">
                  <>
                    <figure className="m-0">
                      <div className="pos-form-group--number mt-2">
                        <button
                          className="up"
                          onClick={(e) =>
                            handleItemQty("increase", index, item)
                          }
                        >
                          <i className="fa fa-plus "></i>
                        </button>
                        <input
                          className="form-control-inputQty"
                          type="text"
                          min="0"
                          value={item.inputQuantity}
                          onChange={(e) =>
                            variationQtyInput(
                              e?.target?.value,
                              index,
                              item,
                              "inputQuantity"
                            )
                          }
                        />

                        <button
                          className="down"
                          onClick={(e) =>
                            handleItemQty("decrease", index, item)
                          }
                        >
                          <i className="fa fa-minus "></i>
                        </button>
                      </div>
                    </figure>
                  </>
                </div>
                <p className="col-auto">
                  {item.Quantity > 0
                    ? `  InStock: ${item.Quantity}`
                    : "  Out Of Stock"}
                </p>
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  className="col-auto"
                >
                  ${item.FinalPrice || 0}
                </div>
                {/* <div className="d-flex align-items-center col-md-4">${item.FinalPrice || 0}</div> */}
              </div>
              <hr />
            </div>
          ))}
        {itemsList == 0 ? (
          <p className="d-flex justify-content-center fs-4">
            Please Scan Items
          </p>
        ) : (
          <div
          style={{
            position: "fixed",
            bottom: "0",
            left: "7px",
            right: "7px",
            backgroundColor: "#ffffff",
            zIndex: "9999999",
            overflow: "hidden",
            boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
            borderRadius: "5px",
          }}
          className="pos-product-action-wrapper d-flex justify-content-between p-3"
        >
          <div className="row w-100">
            {!isModal ? (
              <div className="d-flex justify-content-between w-100">
                <button
                  className="pos-ps-btn pos-button_rp btn-blk_Qty m-2 w-50"
                  onClick={() => setIsModal(true)}
                >
                  Back to Scanner
                </button>
                <button
        // id="ScannerModel"
        // tabIndex={-1}
        // aria-hidden="true"
        // data-bs-backdrop="static"
                        data-bs-dismiss="modal"
                aria-label="Close"
                  className="pos-ps-btn pos-button_rp btn-blk_Qty m-2 w-50"
                  onClick={(e) => {
                    if (itemsList?.length === 0) {
                      toastError("Product Not Found!", "bottom-center");
                    } else {
                      bulkAddToCart(e);
                      // setIsModal(true)
                      setStartScannerCamera(false)
                    }
                  }}
                >
                  ADD TO CART
                </button>
              </div>
            ) : (
              <button
                className="pos-ps-btn pos-button_rp btn-blk_Qty m-2 w-100"
                onClick={() => setIsModal(false)}
              >
                REVIEW ITEMS ({itemsList?.length})
              </button>
            )}
          </div>
        </div>
        
        )}
      </div>
    </div>
  );
}

export default Scanner;
